// extracted by mini-css-extract-plugin
export default {"header":"styles_header__7auG9","filters":"styles_filters__W3DdM","search":"styles_search__cpR8B","articleCategoryPage":"styles_articleCategoryPage__USzJH"};